import { CHANCELLERIES_ENDPOINT } from 'common/constants'
import { request } from 'common/utils'
import query from 'packages-mui/chancelleries/graphql/getChancellery.graphql'
import { GetChancelleryQuery } from 'packages-mui/chancelleries/interfaces/schemaDefinition'

export const getChancellery = async (id: string): Promise<GetChancelleryQuery['chancellery']> =>
  (await request<GetChancelleryQuery>(CHANCELLERIES_ENDPOINT, query, { id })).chancellery
